exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ck-ordered-list,\n.ck-unordered-list {\n  margin-left: 1em;\n  list-style-position: outside;\n}\n\n.ck-ordered-list {\n  list-style-type: decimal;\n}\n\n.ck-unordered-list {\n  list-style-type: disc;\n}\n\n.ck-ordered-list .ck-ordered-list,\n.ck-unordered-list .ck-unordered-list,\n.ck-ordered-list .ck-unordered-list,\n.ck-unordered-list .ck-ordered-list {\n  padding-left: 1em;\n}\n", ""]);

// exports
